<template>
  <v-menu
    :close-on-content-click="false"
    bottom
    offset-y
    rounded="sm"
    :max-width="is_mobile ? '94%' : '80%'"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        :class="$style.apps"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>

    <v-list :class="$style.widget_block">
      <div :class="$style.widget_title">
        <span
          class="display-2"
        >Сервисы АТОЛ</span>
      </div>
      <div
        class="d-flex flex-wrap"
        :class="$style.widgets_container"
      >
        <div
          v-for="item in widgets_without_atollkp"
          :key="item.name"
        >
          <a
            :href=item.url
            :class="[$style.widget_a, { [$style.widget_is_active]: !item.is_active }]"
            target="_blank"
          >
            <div
              :class="$style.widget"
            >
              <img
                v-if="item.is_active"
                :class="$style.widget_icon"
                :src=item.icon
                alt="icon"
              >
              <img
                v-if="!item.is_active"
                :class="$style.widget_icon"
                :src=item.icon_disabled
                alt="icon_disabled"
              >
              <span :class="$style.widget_text">{{ item.name }}</span>
            </div>
          </a>
        </div>

      </div>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { user_store, global_store } from '@/store';

@Component
export default class WidgetsMenu extends Vue {
  get widgets_without_atollkp() {
    return user_store.state.me.widgets.filter((item) => item.name !== 'АТОЛ ЛКП' || item.url !== 'https://lkp.atol.ru');
  }

  get is_mobile() {
    return global_store.state.isMobile;
  }
}
</script>

<style module lang="scss">
.widget_icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.widget_text {
  padding-top: 8px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #696C86;
  cursor: pointer;
}
.widget_title {
  font-style: 18px;
  font-weight: 600;
  line-height: 20px;
  color: #696C86;
  margin: 24px 24px 0 24px;
}
.widgets_container {
  margin: 24px;
}
.widget_block {
  width: 408px;
}
.widget {
  width: 120px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;

  @media (max-width: 599px) {
    width: 100px;
  }
}
.widget_is_active {
    pointer-events: none;
}
.widget_a {
  display: block;
  text-decoration: none;

    &:hover {
      background-color: #eae8e8;
      border-radius: 8px;
    }
}
</style>
